import type { ReactNode } from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';

type Props = {
  title: string;
  description?: string;
  rightControls?: ReactNode;
  className?: string;
};

export const PageHeader = memo(({ title, description, rightControls, className }: Props) => {
  return (
    <div className={cn('flex items-center justify-between mb-6', className)}>
      <div>
        <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
        <p className="text-muted-foreground">{description}</p>
      </div>
      {rightControls}
    </div>
  );
});
